import {
  MODAL_HIDDEN,
  MODAL_INTERACTION,
  MODAL_DATA_LOADED,
} from '../actions/constants';
import { GROUP_BY } from '../util/enums/EnumLayers';
import AggregateFunction from '../util/AggregateFunction';
import AggregateColumn from '../util/AggregateColumn';
import ModalGroupBy from '../components/modals/ModalGroupBy';
import {
  GROUP_BY_MODE,
  ADD_COLUMNS_MODE,
} from '../util/enums/EnumAggregateMode';

const INITIAL_STATE = {
  selected: [], // AggregateColumn objs
  plusClicked: false,
  readyForSave: true,

  countChecked: true,
  percentChecked: false,
  aggFunctions: [], // AggregateFunction objects
  mode: GROUP_BY_MODE,
  moreClicked: false,
  advancedClicked: false,
  selectedOp: null, // AggregateOperation
};

function interaction(state, payload) {
  switch (payload.section) {
    case 'addColumn': {
      const newCol = AggregateColumn.fromColumn(
        payload.columnName,
        payload.extra,
      );
      return {
        ...state,
        selected: [...state.selected, newCol],
        plusClicked: false,
      };
    }
    case 'removeColumn': {
      return {
        ...state,
        selected: state.selected.filter(
          (aggCol) => !aggCol.equals(payload.aggCol),
        ),
        selectedOp: null, // reset
      };
    }
    case 'changeAgg': {
      const indexOfUpdated = state.selected.findIndex((aggCol) =>
        aggCol.equals(payload.aggCol),
      );
      const newAggCol = new AggregateColumn(
        payload.aggCol.alias(),
        payload.aggCol.name(),
        payload.aggregation,
      );
      return {
        ...state,
        selected: [
          ...state.selected.slice(0, indexOfUpdated),
          newAggCol,
          ...state.selected.slice(indexOfUpdated + 1),
        ],
      };
    }
    case 'plusClicked':
      return { ...state, plusClicked: true };
    case 'moreClicked':
      return { ...state, moreClicked: true };
    case 'advanced':
      return { ...state, advancedClicked: true };
    case 'undoMore':
      return { ...state, selectedOp: null, moreClicked: false };
    case 'countToggled':
      return {
        ...state,
        countChecked: !state.countChecked,
        moreClicked: false,
      };
    case 'percentToggled':
      return {
        ...state,
        percentChecked: !state.percentChecked,
        moreClicked: false,
      };
    case 'mode':
      return { ...state, mode: payload.newValue };
    case 'chooseOp':
      return { ...state, selectedOp: payload.aggregateOperation };
    case 'removeAgg':
      return {
        ...state,
        aggFunctions: state.aggFunctions.filter(
          (ag) => ag !== payload.aggregateFunction,
        ),
      };
    case 'functionArg':
      return {
        ...state,
        selectedOp: null, // reset
        moreClicked: false,
        aggFunctions: [
          ...state.aggFunctions,
          new AggregateFunction(state.selectedOp, payload.columnName),
        ],
      };
    default:
      return state;
  }
}

const modalGroupBy = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_DATA_LOADED:
      if (action.payload.modal === ModalGroupBy) {
        if (action.payload.relevantColumnName) {
          return {
            ...INITIAL_STATE,
            selected: [
              AggregateColumn.fromColumn(
                action.payload.relevantColumnName,
                action.payload.additionalOptions.aggregation,
              ),
            ],
            countChecked: !action.payload.additionalOptions.percent,
            percentChecked: action.payload.additionalOptions.percent,
          };
        }
        if (action.payload.additionalOptions) {
          if (action.payload.additionalOptions.aggregate) {
            // user wants to see all options
            return {
              ...INITIAL_STATE,
              countChecked: false,
              moreClicked: true,
              mode: ADD_COLUMNS_MODE,
              readyForSave: false,
            };
          }
          // user wants specific operation selected
          return {
            ...INITIAL_STATE,
            aggFunctions: [
              new AggregateFunction(
                action.payload.additionalOptions.selectedOp,
                action.payload.additionalOptions.columnName,
              ),
            ],
            countChecked: false,
          };
        }
        if (action.payload.existingLayer) {
          return {
            ...INITIAL_STATE,
            selected: action.payload.existingLayer.keys(),
            countChecked: action.payload.existingLayer.count(),
            percentChecked: action.payload.existingLayer.percent(),
            aggFunctions: action.payload.existingLayer.functions(),
            mode: action.payload.existingLayer.mode(),
          };
        }
      }
      return state;
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== GROUP_BY) {
        return state;
      }
      const newState = interaction(state, action.payload.props);
      newState.readyForSave =
        newState.selected.length > 0 ||
        newState.countChecked ||
        newState.percentChecked ||
        newState.aggFunctions.length > 0;
      return newState;
    }
    default:
      return state;
  }
};

export default modalGroupBy;
